export const lang = {
    DaofuCounty:'道孚县',
    weathertxt:'三日天气',
    y:'年',
    m:'月',
    d:'日',
    sys:'扫一扫',
    gzwxgzh:'关注微信公众号',
    zxrx:'咨询热线',
    tsrx:'投诉热线',
    jyrx:'救援热线',
    lyjgfwpt:'旅游监管服务平台',
    gfwz:'官方网址',
    dcdf:'多彩道孚',
    dlwz:'地理位置',
    qhhj:'气候环境',
    whdy:'文化底蕴',
    mzfq:'民族风情',
    fywh:'非遗文化',
    yywh:'音乐文化',
    wdwh:'舞蹈文化',
    fswh:'服饰文化',
    ycwh:'演出文化',
    
  }
  


// WEBPACK FOOTER //
// ./src/assets/i18/zh.js